import { Flex } from "@/atoms"
import { Status } from "./Status"

import { WorkLoadStatuses } from "@/domain/application"
import styles from "./ImpactCard.module.scss"

import type { StatusesProps } from "."

export const Statuses = (props: StatusesProps) => {
  const { hideZeroValues, t } = props

  return (
    <Flex gap={16} align="center" className={styles.statuses}>
      {WorkLoadStatuses.map((status) => {
        if (hideZeroValues && props[status] === 0) return null

        const value = props[status]
        const key = `${status}_${value}`

        return <Status key={key} status={status} value={value} t={t} />
      })}
    </Flex>
  )
}
